<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Screenreaders</h1>
        <p>Use screenreader utilities to hide elements on all devices except screen readers.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">
&lt;a class="sr-only sr-only-focusable" href="#content"&gt;Skip to main content&lt;/a&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Variants / Modifiers</p>
            <p>Hide an element to all devices except screen readers with <span class="code">.sr-only</span>. Combine <span class="code">.sr-only</span> with <span class="code">.sr-only-focusable</span> to show the element again when it’s focused (e.g. by a keyboard-only user).</p>
          </div>
        </div>
        <!-- <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Accessibility</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
          </div>
        </div> -->
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Screenreaders"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Screenreaders.vue